module.exports = __webpack_public_path__ + "img/bg_sidebar.00216dee.jpg";